/**
 * A claim that appears more than once in a token is decoded as an array of
 * values instead of a string (see roleContainsAdmin for the role variant).
 * For claims displayed as a single string (name, email), take the last value —
 * when the backend issues duplicates, the canonical profile value is added
 * after the stored account claims.
 */
export const claimValueAsString = (claim: unknown): string => {
  if (Array.isArray(claim)) {
    const last = claim[claim.length - 1];
    return typeof last === "string" ? last : "";
  }
  return typeof claim === "string" ? claim : "";
};
